import { t } from '@hefe/i18n';
import { Club, ClubSettings } from '@hefe/models';
import { ClubSlice } from '@hefe/store';
import { Descriptions, Space, Switch, Typography } from 'antd';
import _ from 'lodash';
import { useState } from 'react';
import { useAppDispatch } from '../../../../store/store';

interface ClubSettingsComponentProps {
  club: Club;
}

export default function ClubSettingsComponent(
  props: ClubSettingsComponentProps
) {
  const { club } = props;

  const [saving, setSaving] = useState(false);
  const dispatch = useAppDispatch();

  const settings = club?.settings as ClubSettings | undefined;

  const updateSettings = (newSettings: ClubSettings) => {
    setSaving(true);
    dispatch(ClubSlice.updateClubSettings(newSettings))
      .unwrap()
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <Descriptions bordered column={1}>
      <Descriptions.Item
        label={t('club_settings.functions.items.partners.title')}
      >
        <Space direction="vertical">
          <Switch
            loading={saving}
            defaultChecked={settings?.general?.functions?.partners}
            onChange={(checked) => {
              const newSettings = _.cloneDeep(settings);
              if (!newSettings) return;
              _.set(newSettings, 'general.functions.partners', checked);
              updateSettings(newSettings as ClubSettings);
            }}
          />
          <Typography.Text style={{ fontSize: 10 }}>
            {t('club_settings.functions.items.partners.description')}
          </Typography.Text>
        </Space>
      </Descriptions.Item>
    </Descriptions>
  );
}
